import './styles.scss'

import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import B2BecLink from '@/components/B2BLink'
import { ChevronRightIcon } from '@/components/Icons'
import { SHOP_CATEGORY_TYPE } from '@/libs/constants'

const SHOP_CATEGORY_URL = {
  [SHOP_CATEGORY_TYPE.MACHINES]: '/categories',
  [SHOP_CATEGORY_TYPE.ACCESSORIES]: '/categories/accessories',
  [SHOP_CATEGORY_TYPE.DETERGENTS]: '/categories/detergents',
}

const getImagePath = (type, context = 'karcher') => {
  const basePath = context === 'futuretech' ? 'futuretech' : 'categories'
  try {
    const image = require(`../../assets/img/${basePath}/${type}.webp`)
    return image.default || image
  } catch {
    return null
  }
}

const getFallbackImagePath = (type, context = 'karcher') => {
  const basePath = context === 'futuretech' ? 'futuretech' : 'categories'
  try {
    const image = require(`../../assets/img/${basePath}/${type}.jpg`)
    return image.default || image
  } catch {
    return null
  }
}

const B2becShopCategoryBlock = ({
  type,
  context = 'karcher',
  priority = false,
}) => {
  const { t } = useTranslation()
  const [imageSrc, setImageSrc] = useState('')
  const [imageLoaded, setImageLoaded] = useState(false)
  const [imageError, setImageError] = useState(false)

  useEffect(() => {
    const src = getImagePath(type, context)
    if (src) {
      setImageSrc(src)
      setImageError(false)

      // Preload critical images
      if (priority) {
        const link = document.createElement('link')
        link.rel = 'preload'
        link.as = 'image'
        link.href = src
        link.fetchPriority = 'high'
        document.head.append(link)

        return () => {
          if (document.head.contains(link)) {
            link.remove()
          }
        }
      }
    } else {
      // Try fallback if main image not found
      const fallbackSrc = getFallbackImagePath(type, context)
      if (fallbackSrc) {
        setImageSrc(fallbackSrc)
        setImageError(false)
      }
    }
  }, [type, context, priority])

  const handleImageError = () => {
    if (!imageError) {
      // Try fallback image
      const fallbackSrc = getFallbackImagePath(type, context)
      if (fallbackSrc) {
        setImageError(true)
        setImageSrc(fallbackSrc)
      }
    }
  }

  return (
    <div className={`b2bec-shop-category b2bec-shop-category--${type}`}>
      <B2BecLink
        className="b2bec-shop-category__link"
        to={SHOP_CATEGORY_URL[type]}
      >
        <div className="b2bec-shop-category__image">
          {imageSrc && (
            <img
              src={imageSrc}
              alt={t(`shopByCategory.${type}`)}
              className="b2bec-shop-category__img"
              loading={priority ? 'eager' : 'lazy'}
              fetchPriority={priority ? 'high' : 'auto'}
              onLoad={() => setImageLoaded(true)}
              onError={handleImageError}
              style={{
                opacity: imageLoaded ? 1 : 0,
                transition: 'opacity 0.2s ease-in-out',
              }}
            />
          )}
        </div>
        <div className="b2bec-shop-category__content">
          <h3 className="b2bec-shop-category__title">
            {t(`shopByCategory.${type}`)}
          </h3>
          <span>{t('shopByCategory.browseNow')}</span>
          <ChevronRightIcon style={{ marginLeft: 6, height: 10 }} />
        </div>
      </B2BecLink>
    </div>
  )
}

export default B2becShopCategoryBlock
